import { c as _c } from "react/compiler-runtime";
interface StartIconProps {
  size?: number;
  color?: string;
}
const StartIcon = t0 => {
  const $ = _c(8);
  const {
    size: t1,
    color: t2
  } = t0;
  const size = t1 === undefined ? 38 : t1;
  const color = t2 === undefined ? "#EAEBEC" : t2;
  let t3;
  if ($[0] !== size) {
    t3 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as React.CSSProperties;
  let t5;
  if ($[2] !== color) {
    t5 = <path d="M17.2236 5.43604C17.9496 3.96503 20.0475 3.96503 20.7734 5.43604L24.4707 12.9272L32.7383 14.1284C34.3615 14.3644 35.0096 16.3594 33.835 17.5044L27.8525 23.3354L29.2646 31.5698C29.5419 33.1866 27.8455 34.419 26.3936 33.6558L18.999 29.769L11.6045 33.6558C10.1525 34.4191 8.4552 33.1866 8.73242 31.5698L10.1445 23.3354L4.16211 17.5044C2.98772 16.3594 3.63579 14.3646 5.25879 14.1284L13.5264 12.9272L17.2236 5.43604Z" fill={color} />;
    $[2] = color;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== color || $[5] !== t4 || $[6] !== t5) {
    t6 = <svg className="dynamic-size" style={t4} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38" fill={color}>{t5}</svg>;
    $[4] = color;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export default StartIcon;